import './ChangePassword.css';
import { useState, useEffect } from 'react';
import EyeIcon from '../../assets/icons/eye.svg?react';
import EyeOffIcon from '../../assets/icons/eye-off.svg?react';
import { useAuthContext } from '../../contexts/AuthContext';
import { useChangePassword } from '../../hooks/queries/authQueries';
import { useNavigate } from 'react-router-dom';
import ChangePasswordSuccessModal from './components/ChangePasswordSuccessModal';
const ChangePassword = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const changePassword = useChangePassword();
  const [isPending, setIsPending] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    userSysId: '',
    currentPassword: '',
    newPassword: ''
  });

  // user가 로드되면 formData 업데이트
  useEffect(() => {
    if (user?.UserSysId) {
      setFormData(prev => ({
        ...prev,
        userSysId: user.UserSysId
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsPending(true);
      await changePassword.mutateAsync(formData);
      setIsSuccessModalOpen(true);
    } catch (error) {
      console.error(error);
      alert('비밀번호 변경에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };

  const handleSuccessModalClose = () => {
    setIsSuccessModalOpen(false);
    navigate('/login', { replace: true });
  };

  return (
    <div className="change-password-container h-full w-full bg-body flex justify-center align-center page-container">
      <div className="change-password-form-container flex flex-col align-center gap-20">
        <h2 className="text-h2 text-gray-700">비밀번호 변경</h2>
        <div className='flex flex-col gap-10 w-full'>
          <div className="change-password-form-group flex flex-col gap-5 w-full">
            <label htmlFor="current-password" className='text-b2-700 text-gray-700'>현재 비밀번호</label>
            <div className="relative">
                <input type={showCurrentPassword ? "text" : "password"} id="current-password" name="currentPassword" className="input-primary w-full text-b2-400 text-gray-600" placeholder='현재 비밀번호를 입력해주세요.' value={formData.currentPassword} onChange={handleChange} />
                <button className="password-toggle-btn" onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
                  {showCurrentPassword ? <EyeOffIcon color="var(--gray-700)"/> : <EyeIcon color="var(--gray-700)"/>}
                </button>
            </div>
          </div>
          <div className="change-password-form-group flex flex-col gap-5 w-full">
            <label htmlFor="new-password" className='text-b2-700 text-gray-700'>새로운 비밀번호</label>
            <div className="relative">
                <input type={showNewPassword ? "text" : "password"} id="new-password" name="newPassword" className="input-primary w-full text-b2-400 text-gray-600" placeholder='새로운 비밀번호를 입력해주세요.' value={formData.newPassword} onChange={handleChange} />
                <button className="password-toggle-btn" onClick={() => setShowNewPassword(!showNewPassword)}>
                  {showNewPassword ? <EyeOffIcon color="var(--gray-700)"/> : <EyeIcon color="var(--gray-700)"/>}
                </button>
            </div>
          </div>
          <button className="btn btn-primary big-btn w-full" onClick={handleSubmit} disabled={isPending}>{isPending ? '변경중...' : '비밀번호 변경'}</button>
          <button className="btn icon-btn big-btn w-full text-gray-600">취소하기</button>
        </div>
      </div>
      {isSuccessModalOpen && <ChangePasswordSuccessModal onClose={handleSuccessModalClose} />}
    </div>
  )
}

export default ChangePassword